export enum ProductInventoryStatus {
  inStock = 'inStock',
  lowStock = 'lowStock',
  outOfStock = 'outOfStock',
}
